import { Component, OnInit, Input } from '@angular/core';
import { LoginArt } from '../../models/login-art.enum';

@Component({
  selector: 'app-login-art',
  templateUrl: './login-art.component.html',
  styleUrls: ['./login-art.component.scss']
})
export class LoginArtComponent implements OnInit {
  @Input()
  art: LoginArt = LoginArt.login;

  constructor() { }

  ngOnInit() {
  }

}
